import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { clearVendor } from '../state';
import { useGetVendorByIdQuery } from '../../../services/VendorService';
import { PageContainer, PageCard } from '../../common/components/styled-ui-elements';
import { VendorEditHeader, VendorEditForm } from '../components/VendorForm';
import { VendorLoadingState, VendorErrorState } from '../components/shared/states';

const VendorEdit: React.FC = () => {
  const [searchParams] = useSearchParams();
  const vendorId = searchParams.get('id') || '';
  const dispatch = useAppDispatch();

  const {
    isLoading: isLoadingVendor,
    isError,
    error,
  } = useGetVendorByIdQuery(vendorId, {
    skip: !vendorId,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (vendorId) {
      dispatch(clearVendor());
    }
  }, [dispatch, vendorId]);

  if (isLoadingVendor) {
    return <VendorLoadingState message="Loading vendor details..." />;
  }

  if (isError || !vendorId) {
    const errorMessage = !vendorId
      ? 'No vendor ID provided. Please provide a valid vendor ID in the URL.'
      : 'Failed to load vendor. Please check the vendor ID and try again.';
    const errorDetails = isError && error && 'message' in error
      ? (error as { message: string }).message
      : undefined;

    return <VendorErrorState message={errorMessage} details={errorDetails} />;
  }

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          <VendorEditHeader />
          <VendorEditForm />
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default VendorEdit;
